import React, { Component } from "react";
import { DatabaseOutlined, GlobalOutlined } from "@ant-design/icons";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import ReportWidjets from "./ReportWidjets";
/* Redesigned filter panels. The originals are left in place for revert:
   Filters/index.js (data) and Filters/CustomFilters.js (global). */
// import Filters from "./Filters/index";
import Filters from "./Filters/DataFiltersPanel";
import { Row, Col, Select, Typography, Skeleton, Tabs, Button, Space, Popover, message, Collapse } from "antd";
import ReactFullscreen from "react-easyfullscreen";
import ConfirmDialog from "../../components/common/ConfirmDialog";
import { getResourcesAsync } from "../../redux/resourceSlice";
import {
  getBoardsAsync,
  updateSelectedBoard,
  getBoardByIdAsync,
  deleteBoardByIdAsync,
  resetBoardData,
  resetAllBoardData,
} from "../../redux/boardSlice";

// import CustomFilters from "./Filters/CustomFilters";
import CustomFilters from "./Filters/GlobalFiltersPanel";
import "./dashboardStyles.css";
import NotFound from "../../components/NotFound";
import DashboardView from "../DashboardView";
import MaterialDesignIcon from "../../components/common/MaterialDesignIcon";
// the editor toolbar's Refresh icon - same asset, so reload looks the same in both places
import RefreshIcon from "../../assets/icons/reset-icon.svg";
const { Option } = Select;
const { Text, Title } = Typography;
const { TabPane } = Tabs;
const { Panel } = Collapse;
class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      layout: [],
      value: "",
      timce: 100000000,
      anchorEl: null,
      setAnchorEl: null,
      visible: "invisible",
      selectedResource: null,
      // deleting the board is confirmed through the shared ConfirmDialog
      isDeleteConfirmOpen: false,
      /* Whether the board is currently filling the screen. Read off the document (see
         syncFullScreen) rather than set by the button, because Esc and F11 change it
         too - the header has to keep saying which way the toggle will go. */
      isFullScreen: false,
    };
    this.handleBannerChange = this.handleBannerChange.bind(this);
    // the widget rows live inside ReportWidjets, so board-level Export goes through here
    this.widgetsRef = React.createRef();

    //  this.handleClose = this.handleClose.bind(this);
  }

  handleClose(event, newValue) {
    this.setState({
      visible: "invisible",
      value: "",
    });
  }

  handleBannerChange(event, newValue) {
    //  console.log(event.currentTarget)
    if (newValue === "fullscreen") {
      this.setState({
        visible: "visible",
        value: newValue,
      });
    } else if (newValue === "refresh") {
      this.setState({
        anchorEl: true,
        // setAnchorEl: event.currentTarget
      });
    } else if (newValue === "export") {
      /* There was no branch for this at all, so the Export button in the board header
         rendered and did nothing. On a dashboard download is now a per-widget property
         and each widget has its own button; this stays for reports, and for dashboards
         saved while board-level download was still a thing. */
      this.widgetsRef.current?.downloadAllWidgets?.();
    }
  }

  syncFullScreen = () => {
    const current = document.fullscreenElement || document.webkitFullscreenElement;
    this.setState({ isFullScreen: Boolean(current) });
  };

  componentDidMount() {
    // console.log(this.state.time)

    document.addEventListener("fullscreenchange", this.syncFullScreen);
    document.addEventListener("webkitfullscreenchange", this.syncFullScreen);

    // if (!this.props.boards.selectedBoard) {
    this.props.getBoardByIdAsync({ id: this.props.match.params.boardId });
    // }

    // this.props.getResources()

    this.setState({
      visible: "invisible",
    });

    if (localStorage.getItem("setTimeRefresh")) {
      setInterval(() => window.location.reload(false), localStorage.getItem("setTimeRefresh"));
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // if (this.props.match.params.boardId) {
    //   this.props.getBoardByIdAsync({ id: this.props.match.params.boardId });
    // }
    if (prevProps.match.params.boardId !== this.props.match.params.boardId) {
      this.props.getBoardByIdAsync({ id: this.props.match.params.boardId });
    }
    if (this.props.boards && this.props.boards.boardDeleteState === "success") {
      this.props.resetBoardData();
      this.props.history.push("/");
    }
  }

  componentWillUnmount() {
    console.log("UNMOUNTING===>>", this.props.match);
    document.removeEventListener("fullscreenchange", this.syncFullScreen);
    document.removeEventListener("webkitfullscreenchange", this.syncFullScreen);
    // this.props.resetAllBoardData()
  }

  onApplyFilterToResource = (resource) => {
    /* Was `resources: [resource]`, which replaced the board's whole resource list with
       the one being filtered - on a dashboard, applying a global filter to one widget
       made every other widget disappear. Only the matching resource is swapped. */
    const board = this.props.boards.selectedBoard;
    const key = (r) => r?.connectionData?.id ?? r?.id;

    this.props.updateSelectedBoard({
      ...board,
      resources: (board?.resources || []).map((r) => (key(r) === key(resource) ? resource : r)),
    });
    console.log("APPLY FILTERS TO ====>>>", resource);
    setTimeout(() => {
      this.setState({
        selectedResource: resource,
      });
    }, 100);
  };

  onApplyDataFilterToResource = (resource) => {
    console.log("APPLY DATA FILTERS TO ====>>>", resource);
    this.setState({
      selectedResource: null,
    });
    setTimeout(() => {
      this.setState({
        selectedResource: resource,
      });
      message.info("Filters have been applied!");
    }, 100);
  };

  onResetFilterToResource = (resource) => {
    console.log("APPLY DATA FILTERS TO ====>>>", resource);
    this.setState({
      selectedResource: { ...resource, dataFilters: [] },
    });
    message.info("Filters have been removed!");
  };

  handleLogOut = () => {
    this.props.logOut();
  };

  confirmDeleteBoard = () => {
    this.setState({ isDeleteConfirmOpen: false });
    this.props
      .deleteBoardById(this.props.match.params.boardId)
      .then(() => message.success("Board deleted successfully!"))
      .catch((err) => message.error("Oops, Board is not deleted!"));
  };

  /* Who made this board and when it last changed.

     This used to be printed inside every table widget, which meant a four-widget
     dashboard repeated the same three lines four times for information that describes
     the BOARD, not any one widget. It is rendered once here instead, under the widgets.

     "Created By" is the signed-in user's email, which is what the widget showed - the
     board record carries no author field, so a name or role is not available yet. */
  renderBoardMeta = (board) => {
    const stamp = (value) => {
      if (!value) return null;
      const d = new Date(value);
      if (Number.isNaN(d.getTime())) return null;
      const date = `${d.getFullYear()}/${String(d.getMonth() + 1).padStart(2, "0")}/${String(d.getDate()).padStart(2, "0")}`;
      return `${date} ${d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" })}`;
    };

    const email = this.props.user?.user?.username || "";
    const rows = [
      { label: "Created By", value: board.createdBy || email },
      { label: "Created At", value: stamp(board.createdAt) },
      { label: "Last Modified", value: stamp(board.updatedAt) },
      { label: "Modified By", value: board.modifiedBy || email },
    ];

    // with no dates and no signed-in user there is nothing to state
    if (!rows.some((r) => r.value)) return null;

    return (
      <div className="dbv-meta-card">
        {rows.map((row) => (
          <div className="dbv-meta-row" key={row.label}>
            <span className="dbv-meta-label">{row.label}:</span>
            <span className="dbv-meta-value">{row.value || "—"}</span>
          </div>
        ))}
      </div>
    );
  };

  render() {
    const handleInterval = (_event) => {
      console.log("_event.target.value", _event.target.dataset);
      localStorage.setItem("setTimeRefresh", Number(_event.target.dataset.value) * 1000);
      if (localStorage.getItem("setTimeRefresh")) {
        setInterval(() => window.location.reload(false), Number(localStorage.getItem("setTimeRefresh")));
      } else {
        setInterval(() => window.location.reload(false), Number(_event.target.dataset.value) * 1000);
      }

      this.setState({
        anchorEl: false,
      });
    };

    // ── OLD BOARD VIEW (kept for revert) ──
    // Replaced by the header / filters / widgets layout below.
    //     return (
    //       <DashboardView>
    //         <>
    //           <Row>
    //             <Col span={20}>
    //               <Title level={5}>{this.props.boards.selectedBoard && this.props.boards.selectedBoard.name}</Title>
    //             </Col>
    //
    //             <Col span={4}>
    //               <div
    //                 style={{
    //                   width: "100%",
    //                   display: "flex",
    //                   flexDirection: "row-reverse",
    //                   textAlign: "right",
    //                 }}
    //               >
    //                 <Button
    //                   type="link"
    //                   onClick={() => {
    //                     window.history.back();
    //                   }}
    //                   style={{ marginLeft: "12px" }}
    //                 >
    //                   Back
    //                 </Button>
    //                 {/* {localStorage.getItem("IsSpecialUser") === "true" ? (
    //                   <>
    //                     <Button
    //                       type="link"
    //                       onClick={async () => {
    //                         this.props.history.push("/editor/dashboard/" + this.props.match.params.boardId);
    //                       }}
    //                       style={{ marginLeft: "12px" }}
    //                       disabled={
    //                         !localStorage.getItem("IsSpecialUser") &&
    //                         this.props.currentAppPermissions &&
    //                         this.props.currentAppPermissions.indexOf("CreateDashboard") === -1
    //                       }
    //                     >
    //                       Edit
    //                     </Button>
    //                     <Popconfirm
    //                       title={`Are you sure to delete this ${
    //                         this.props.boards.selectedBoard &&
    //                         this.props.boards.selectedBoard.configDetails.boardType === "reports"
    //                           ? "Report"
    //                           : "Dashboard"
    //                       } ?`}
    //                       placement="bottom"
    //                       onConfirm={this.confirmDeleteBoard}
    //                       okText="Yes"
    //                       cancelText="No"
    //                       disabled={
    //                         !localStorage.getItem("IsSpecialUser") &&
    //                         this.props.currentAppPermissions &&
    //                         this.props.currentAppPermissions.indexOf("CreateDashboard") === -1
    //                       }
    //                     >
    //                       <Button
    //                         type="link"
    //                         disabled={
    //                           !localStorage.getItem("IsSpecialUser") &&
    //                           this.props.currentAppPermissions &&
    //                           this.props.currentAppPermissions.indexOf("CreateDashboard") === -1
    //                         }
    //                       >
    //                         Delete
    //                       </Button>
    //                     </Popconfirm>
    //                   </>
    //                 ) : null} */}
    //
    //                 <>
    //                   <Button
    //                     type="link"
    //                     onClick={async () => {
    //                       this.props.history.push("/editor/dashboard/" + this.props.match.params.boardId);
    //                     }}
    //                     style={{ marginLeft: "12px" }}
    //                     disabled={
    //                       !localStorage.getItem("IsSpecialUser") &&
    //                       this.props.currentAppPermissions &&
    //                       this.props.currentAppPermissions.indexOf("CreateDashboard") === -1
    //                     }
    //                   >
    //                     Edit
    //                   </Button>
    //                   <Popconfirm
    //                     title={`Are you sure to delete this ${
    //                       this.props.boards.selectedBoard &&
    //                       this.props.boards.selectedBoard.configDetails.boardType === "reports"
    //                         ? "Report"
    //                         : "Dashboard"
    //                     } ?`}
    //                     placement="bottom"
    //                     onConfirm={this.confirmDeleteBoard}
    //                     okText="Yes"
    //                     cancelText="No"
    //                     disabled={
    //                       !localStorage.getItem("IsSpecialUser") &&
    //                       this.props.currentAppPermissions &&
    //                       this.props.currentAppPermissions.indexOf("CreateDashboard") === -1
    //                     }
    //                   >
    //                     <Button
    //                       type="link"
    //                       disabled={
    //                         !localStorage.getItem("IsSpecialUser") &&
    //                         this.props.currentAppPermissions &&
    //                         this.props.currentAppPermissions.indexOf("CreateDashboard") === -1
    //                       }
    //                     >
    //                       Delete
    //                     </Button>
    //                   </Popconfirm>
    //                 </>
    //               </div>
    //             </Col>
    //           </Row>
    //           <div>
    //             <ReactFullscreen>
    //               {({ ref, onRequest, onExit }) => (
    //                 <div ref={ref} className="view ant-col" style={{ backgroundColor: "white" }}>
    //                   <button
    //                     onClick={() => {
    //                       onExit();
    //                       this.handleClose();
    //                     }}
    //                     className={this.state.visible}
    //                   >
    //                     Exit
    //                   </button>
    //                   <Row>
    //                     <Col span={24}>
    //                       {/* {this.state.anchorEl ?
    //                                                 <Menu
    //                                                     id="simple-menu"
    //                                                     anchorEl={this.state.anchorEl}
    //                                                     keepMounted
    //                                                     open={Boolean(this.state.anchorEl)}
    //                                                     onClose={this.state.setAnchorEl}
    //                                                 >
    //                                                     <MenuItem value="1000000" onClick={handleInterval}>Never</MenuItem>
    //                                                     <MenuItem value="10" onClick={handleInterval}>10 Seconds</MenuItem>
    //                                                     <MenuItem value="60" onClick={handleInterval}>1 Minute</MenuItem>
    //                                                     <MenuItem value="900" onClick={handleInterval}>15 Minutes</MenuItem>
    //                                                     <MenuItem value="3600" onClick={handleInterval}>1 Hour</MenuItem>
    //                                                 </Menu>
    //                                                 : ('')
    //                                             } */}
    //                       {this.props.boards &&
    //                       this.props.boards.selectedBoard &&
    //                       this.props.boards.selectedBoard.properties ? (
    //                         <>
    //                           {this.props.boards.selectedBoard.properties.autorefresh ||
    //                           this.props.boards.selectedBoard.properties.fullscreen ||
    //                           this.props.boards.selectedBoard.properties.csvdownload ||
    //                           this.props.boards.selectedBoard.properties.refresh ? (
    //                             <>
    //                               {/* <BottomNavigation value={this.state.value} onChange={this.handleBannerChange}>
    //                                                                         {!this.props.boards.selectedBoard.properties.autorefresh ? <BottomNavigationAction label="Refresh" value="refresh" icon={<MaterialDesignIcon icon="refresh" />} /> : null}
    //                                                                         {!this.props.boards.selectedBoard.properties.fullscreen ? <BottomNavigationAction label="Auto Run" value="autorun" icon={<MaterialDesignIcon icon="directions_run" />} /> : null}
    //                                                                         {this.props.boards.selectedBoard.properties.csvdownload ? <BottomNavigationAction label="Export" value="reload" icon={<MaterialDesignIcon icon="import_export" />} /> : null}
    //                                                                         {this.props.boards.selectedBoard.properties.refresh ? <BottomNavigationAction onClick={() => window.location.reload(false)} label="Reload Page" value="reload" icon={<MaterialDesignIcon icon="reply" />} /> : null}
    //                                                                         {this.props.boards.selectedBoard.properties.fullscreen ? <BottomNavigationAction onClick={() => onRequest()} label="Full Screen" value="fullscreen" icon={<MaterialDesignIcon icon="fullscreen" />} /> : null}
    //                                                                     </BottomNavigation> */}
    //                               <div
    //                                 style={{
    //                                   margin: "auto",
    //                                   textAlign: "center",
    //                                   padding: "12px",
    //                                 }}
    //                               >
    //                                 <Space>
    //                                   {this.props.boards.selectedBoard.properties.autorefresh ? (
    //                                     <Popover
    //                                       content={
    //                                         <>
    //                                           {/* <a onClick={() => this.setState({ anchorEl: null, setAnchorEl: null })}>Close</a> */}
    //                                           <a data-value="1000000" onClick={handleInterval}>
    //                                             Never
    //                                           </a>
    //                                           <br />
    //                                           <a data-value="30" onClick={handleInterval}>
    //                                             30 Seconds
    //                                           </a>
    //                                           <br />
    //                                           <a data-value="60" onClick={handleInterval}>
    //                                             1 Minute
    //                                           </a>
    //                                           <br />
    //                                           <a data-value="900" onClick={handleInterval}>
    //                                             15 Minutes
    //                                           </a>
    //                                           <br />
    //                                           <a data-value="3600" onClick={handleInterval}>
    //                                             1 Hour
    //                                           </a>
    //                                         </>
    //                                       }
    //                                       title="Refresh Interval"
    //                                       trigger="click"
    //                                       visible={this.state.anchorEl}
    //                                       onVisibleChange={this.handleVisibleChange}
    //                                       placement="bottom"
    //                                     >
    //                                       <Button
    //                                         type="link"
    //                                         onClick={(e) => this.handleBannerChange(e, "refresh")}
    //                                         icon={<MaterialDesignIcon icon="refresh" />}
    //                                       />
    //                                     </Popover>
    //                                   ) : null}
    //                                   {this.props.boards.selectedBoard.properties.fullscreen ? (
    //                                     <Button
    //                                       type="link"
    //                                       onClick={(e) => this.handleBannerChange(e, "autorun")}
    //                                       value=""
    //                                       icon={<MaterialDesignIcon icon="directions_run" />}
    //                                     />
    //                                   ) : null}
    //                                   {this.props.boards.selectedBoard.properties.csvdownload ? (
    //                                     <Button
    //                                       type="link"
    //                                       onClick={(e) => this.handleBannerChange(e, "export")}
    //                                       icon={<MaterialDesignIcon icon="import_export" />}
    //                                     />
    //                                   ) : null}
    //                                   {this.props.boards.selectedBoard.properties.refresh ? (
    //                                     <Button
    //                                       type="link"
    //                                       onClick={() => window.location.reload(false)}
    //                                       icon={<MaterialDesignIcon icon="reply" />}
    //                                     />
    //                                   ) : null}
    //                                   {this.props.boards.selectedBoard.properties.fullscreen ? (
    //                                     <Button
    //                                       type="link"
    //                                       onClick={() => onRequest()}
    //                                       label="Full Screen"
    //                                       value="fullscreen"
    //                                       icon={<MaterialDesignIcon icon="fullscreen" />}
    //                                     />
    //                                   ) : null}
    //                                 </Space>
    //                               </div>
    //                             </>
    //                           ) : (
    //                             ""
    //                           )}
    //                         </>
    //                       ) : this.props.boards.boardsStatus === "pending" ? (
    //                         <div>
    //                           <Skeleton />
    //                         </div>
    //                       ) : null}
    //                     </Col>
    //                   </Row>
    //
    //                   <Collapse>
    //                     <Panel header="Filters" key="1">
    //                       <div>
    //                         <Tabs defaultActiveKey="1">
    //                           <TabPane
    //                             tab={
    //                               <span>
    //                                 <DatabaseOutlined />
    //                                 Data Filters
    //                               </span>
    //                             }
    //                             key="1"
    //                           >
    //                             {this.props.boards && this.props.boards.selectedBoard ? (
    //                               <Filters
    //                                 board={this.props.boards.selectedBoard}
    //                                 onApplyDataFilter={this.onApplyDataFilterToResource}
    //                                 onResetDataFilter={this.onResetFilterToResource}
    //                               />
    //                             ) : this.props.boards.boardsStatus === "pending" ? (
    //                               <div>
    //                                 <Skeleton />
    //                               </div>
    //                             ) : null}
    //                           </TabPane>
    //                           <TabPane
    //                             tab={
    //                               <span>
    //                                 <GlobalOutlined />
    //                                 Global Filters
    //                               </span>
    //                             }
    //                             key="2"
    //                           >
    //                             {this.props.boards && this.props.boards.selectedBoard ? (
    //                               <>
    //                                 <CustomFilters
    //                                   selectedBoard={this.props.boards.selectedBoard}
    //                                   onApplyFilter={this.onApplyFilterToResource}
    //                                 />
    //                                 {/* <ReportWidjets board={this.props.boards.selectedBoard} selectedResource={this.state.selectedResource} /> */}
    //                               </>
    //                             ) : this.props.boards.boardsStatus === "pending" ? (
    //                               <div>
    //                                 <Skeleton />
    //                               </div>
    //                             ) : null}
    //                           </TabPane>
    //                         </Tabs>
    //                       </div>
    //                     </Panel>
    //                   </Collapse>
    //
    //                   {this.props.boards.boardsStatus === "pending" ? (
    //                     <div>
    //                       <Skeleton />
    //                     </div>
    //                   ) : this.props.boards && this.props.boards.selectedBoard ? (
    //                     <div id="report-div">
    //                       <ReportWidjets
    //                         board={this.props.boards.selectedBoard}
    //                         selectedResource={this.state.selectedResource}
    //                       />
    //                     </div>
    //                   ) : null}
    //                 </div>
    //               )}
    //             </ReactFullscreen>
    //           </div>
    //         </>
    //       </DashboardView>
    //     );

    // ── NEW BOARD VIEW ──
    // Page shell only. The widgets, their tables and the created-by footer are still
    // rendered by ReportWidjets / BoardDataTableContainer and are untouched here.
    const board = this.props.boards && this.props.boards.selectedBoard;
    const isReport = board && board.configDetails && board.configDetails.boardType === "reports";
    const typeLabel = isReport ? "Report" : "Dashboard";
    const boardProps = (board && board.properties) || {};
    const hasToolbar = boardProps.autorefresh || boardProps.fullscreen || boardProps.csvdownload || boardProps.refresh;
    // Same gate as the Dashboards list: hidden for users without board rights.
    const canManageBoard =
      localStorage.getItem("IsSpecialUser") === "true" ||
      (this.props.currentAppPermissions || []).indexOf("CreateDashboard") !== -1;
    const today = new Date().toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });

    console.log("boardProps", this.props);

    const BackIcon = (
      <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" width="14" height="14">
        <path d="M10 3L5 8l5 5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
    const EditIcon = (
      <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4" width="14" height="14">
        <path d="M10.5 2.5l3 3-8 8H2.5v-3l8-8z" strokeLinejoin="round" />
      </svg>
    );
    const DeleteIcon = (
      <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4" width="14" height="14">
        <path d="M2.5 4h11M6 4V2.5h4V4M6.5 7v4M9.5 7v4M3.5 4l.8 9.5h7.4L12.5 4" strokeLinecap="round" />
      </svg>
    );
    const FilterIcon = (
      <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" width="14" height="14">
        <path d="M2 3.5h12L9.5 8.5v4l-3 1.5v-5.5L2 3.5z" strokeLinejoin="round" />
      </svg>
    );

    return (
      // noMargin so the grey page canvas runs to the edges; padding lives on .dbv-shell
      <DashboardView noMargin={true}>
        <div className="dbv-shell">
          <ReactFullscreen>
            {({ ref, onRequest, onExit }) => (
              <div ref={ref} className={`view dbv-surface${this.state.isFullScreen ? " dbv-surface--fullscreen" : ""}`}>
                {/* ── OLD EXIT BUTTON (kept for revert) ──
                    Toggled by the `visible` / `invisible` class, which is only ever set by
                    handleBannerChange("fullscreen") - and nothing calls that, so this
                    button never appeared. Exiting is the header's full screen toggle now. */}
                {/* <button
                  onClick={() => {
                    onExit();
                    this.handleClose();
                  }}
                  className={this.state.visible}
                >
                  Exit
                </button> */}

                {/* ── Header ── */}
                <div className="dbv-header">
                  <div className="dbv-header-left">
                    <h1 className="dbv-title">{board ? board.name : typeLabel}</h1>
                    <p className="dbv-subtitle">{today}</p>
                  </div>

                  <div className="dbv-header-actions">
                    {/* Board properties toolbar — same handlers, moved out of the page
                        centre and into the header so the actions sit together. */}
                    {hasToolbar ? (
                      <div className="dbv-tools">
                        {boardProps.autorefresh ? (
                          <Popover
                            content={
                              <div className="dbv-interval-list">
                                <a data-value="1000000" onClick={handleInterval}>
                                  Never
                                </a>
                                <a data-value="30" onClick={handleInterval}>
                                  30 Seconds
                                </a>
                                <a data-value="60" onClick={handleInterval}>
                                  1 Minute
                                </a>
                                <a data-value="900" onClick={handleInterval}>
                                  15 Minutes
                                </a>
                                <a data-value="3600" onClick={handleInterval}>
                                  1 Hour
                                </a>
                              </div>
                            }
                            title="Refresh Interval"
                            trigger="click"
                            visible={this.state.anchorEl}
                            onVisibleChange={this.handleVisibleChange}
                            placement="bottomRight"
                          >
                            <button className="dbv-tool-btn" title="Auto refresh interval">
                              {/* the clock-and-arrow: refreshing on a timer, as against the
                                  plain reload two buttons along */}
                              <MaterialDesignIcon icon="update" />
                            </button>
                          </Popover>
                        ) : null}
                        {/* "Auto run" was gated on the full screen flag and called
                            handleBannerChange with a value it has no branch for, so it
                            has never done anything. Hidden rather than removed. */}
                        {/* {boardProps.fullscreen ? (
                          <button
                            className="dbv-tool-btn"
                            title="Auto run"
                            onClick={(e) => this.handleBannerChange(e, "autorun")}
                          >
                            <MaterialDesignIcon icon="directions_run" />
                          </button>
                        ) : null} */}
                        {boardProps.csvdownload ? (
                          <button
                            className="dbv-tool-btn"
                            title="Export"
                            onClick={(e) => this.handleBannerChange(e, "export")}
                          >
                            <MaterialDesignIcon icon="import_export" />
                          </button>
                        ) : null}
                        {boardProps.refresh ? (
                          <button
                            className="dbv-tool-btn"
                            title="Reload page"
                            onClick={() => window.location.reload(false)}
                          >
                            {/* Was MaterialDesignIcon "reply" - a left-turning arrow, which
                                read as Back sitting two buttons away from the actual Back.
                                This is the same asset the editor toolbar's Refresh button
                                uses, so one reload gesture looks the same in both places. */}
                            <img src={RefreshIcon} alt="" className="dbv-tool-icon" />
                          </button>
                        ) : null}
                        {/* One toggle. It only ever called onRequest(), so once the board
                            filled the screen the only way out was Esc - and the icon still
                            said "expand". The stray Exit button that used to sit above the
                            header was never reachable either: it is shown by
                            handleBannerChange("fullscreen"), which nothing calls. */}
                        {boardProps.fullscreen ? (
                          <button
                            className={`dbv-tool-btn${this.state.isFullScreen ? " dbv-tool-btn--active" : ""}`}
                            title={this.state.isFullScreen ? "Exit full screen" : "Full screen"}
                            onClick={() => (this.state.isFullScreen ? onExit() : onRequest())}
                          >
                            <MaterialDesignIcon icon={this.state.isFullScreen ? "fullscreen_exit" : "fullscreen"} />
                          </button>
                        ) : null}
                      </div>
                    ) : null}

                    {/* Back is not in the mockup but the view is reached from the list,
                        so it stays alongside Edit / Delete. */}
                    <button className="dbv-btn dbv-btn-edit" onClick={() => window.history.back()}>
                      {BackIcon}
                      Back
                    </button>

                    <button
                      className="dbv-btn dbv-btn-edit"
                      onClick={() =>
                        this.props.history.push(
                          `/editor/${isReport ? "reports" : "dashboard"}/${this.props.match.params.boardId}`,
                        )
                      }
                    >
                      {EditIcon}
                      Edit
                    </button>
                    <button
                      className="dbv-btn dbv-btn-delete"
                      onClick={() => this.setState({ isDeleteConfirmOpen: true })}
                    >
                      {DeleteIcon}
                      Delete
                    </button>

                    {/* {canManageBoard ? (
                      <>
                        <button
                          className="dbv-btn dbv-btn-edit"
                          onClick={() =>
                            this.props.history.push(
                              `/editor/${isReport ? "reports" : "dashboard"}/${this.props.match.params.boardId}`,
                            )
                          }
                        >
                          {EditIcon}
                          Edit
                        </button>
                        <button
                          className="dbv-btn dbv-btn-delete"
                          onClick={() => this.setState({ isDeleteConfirmOpen: true })}
                        >
                          {DeleteIcon}
                          Delete
                        </button>
                      </>
                    ) : null} */}
                  </div>
                </div>

                {/* ── Filters ── */}
                <Collapse className="dbv-filters" expandIconPosition="right">
                  <Panel
                    header={
                      <span className="dbv-filters-label">
                        {FilterIcon}
                        Filters
                      </span>
                    }
                    key="1"
                  >
                    <Tabs defaultActiveKey="1">
                      <TabPane
                        tab={
                          <span>
                            <DatabaseOutlined />
                            Data Filters
                          </span>
                        }
                        key="1"
                      >
                        {board ? (
                          <Filters
                            board={board}
                            onApplyDataFilter={this.onApplyDataFilterToResource}
                            onResetDataFilter={this.onResetFilterToResource}
                          />
                        ) : this.props.boards.boardsStatus === "pending" ? (
                          <Skeleton />
                        ) : null}
                      </TabPane>
                      <TabPane
                        tab={
                          <span>
                            <GlobalOutlined />
                            Global Filters
                          </span>
                        }
                        key="2"
                      >
                        {board ? (
                          <CustomFilters selectedBoard={board} onApplyFilter={this.onApplyFilterToResource} />
                        ) : this.props.boards.boardsStatus === "pending" ? (
                          <Skeleton />
                        ) : null}
                      </TabPane>
                    </Tabs>
                  </Panel>
                </Collapse>

                {/* ── Widgets ── */}
                {this.props.boards.boardsStatus === "pending" ? (
                  <div className="dbv-skeleton">
                    <Skeleton active />
                  </div>
                ) : board ? (
                  <>
                    <div id="report-div" className="dbv-widgets">
                      <ReportWidjets
                        ref={this.widgetsRef}
                        board={board}
                        selectedResource={this.state.selectedResource}
                      />
                    </div>
                    {/* ── BOARD META CARD (hidden) ──
                        Created By / Created At / Last Modified / Modified By. Taken off
                        the page so the widgets get the full height and width of it -
                        the card sat under them and pushed the tables up. renderBoardMeta
                        is left in place above; restore this line to bring it back. */}
                    {/* {this.renderBoardMeta(board)} */}
                  </>
                ) : null}
              </div>
            )}
          </ReactFullscreen>

          <ConfirmDialog
            open={this.state.isDeleteConfirmOpen}
            danger
            title={`Delete this ${typeLabel}?`}
            message={`"${board?.name || typeLabel}" will be removed permanently. This cannot be undone.`}
            onCancel={() => this.setState({ isDeleteConfirmOpen: false })}
            onConfirm={this.confirmDeleteBoard}
          />
        </div>
      </DashboardView>
    );
  }
}

const mapStateToProps = (state) => {
  const { boards, user } = state;
  return {
    boards: boards,
    // the meta card shows the signed-in user's email as the board's author
    user: user,
    currentAppPermissions: user.currentAppPermissions ? user.currentAppPermissions : [],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // dispatching plain actions
    getBoardByIdAsync: (data) => dispatch(getBoardByIdAsync(data)),
    updateSelectedBoard: (data) => dispatch(updateSelectedBoard(data)),
    deleteBoardById: (id) => dispatch(deleteBoardByIdAsync(id)),
    resetBoardData: () => dispatch(resetBoardData()),
    resetAllBoardData: () => dispatch(resetAllBoardData()),
    getResources: () => dispatch(getResourcesAsync()),
    // addSelectedBoard: (board) => dispatch(updateSelectedBoard(board)),
    // setOtherUsers: (usersList) => dispatch(setOtherUsers(usersList)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Dashboard));
